<template>
  <div class="temp-container">
    <div class="temp-header flex flex-between">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div>门店装修</div>
      <ul class="flex header-list">
        <!-- <li class="btn">
          <span class="hmicon icon-yulan"></span>预览
        </li>-->
        <li class="btn" @click="save">
          <span class="hmicon icon-baocun"></span>保存
        </li>
        <!-- <li class="btn">
          <span class="hmicon icon-fabu"></span>发布
        </li>-->
      </ul>
    </div>
    <div class="flex">
      <!-- 组件容器 -->
      <div class="component-list">
        <div class="title">基础组件</div>
        <draggable
          class="dragArea list-group flex flex-wrap"
          :list="hmComponents"
          :sort="false"
          :group="{ name: 'component', pull: 'clone', put: false }"
          @change="log"
          :clone="cloneEnd"
        >
          <!-- :group="{ name: 'component', pull: 'clone', put: false }" -->
          <template v-for="(v, i) in hmComponents">
            <div
              class="list-group-item"
              v-if="
                v.type === 'base' &&
                  v.component !== 'search' &&
                  v.component !== 'tabs' &&
                  v.component !== 'goodsList'
              "
              :key="i"
            >
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </draggable>
        <!-- <div class="title">营销组件</div>
        <draggable
          class="dragArea list-group flex flex-wrap"
          :list="hmComponents"
          :sort="false"
          :group="{ name: 'component', pull: 'clone', put: false }"
          @change="log"
          :clone="cloneEnd"
        >
          <template v-for="(v, i) in hmComponents">
            <div class="list-group-item" v-if="v.type === 'marketing'" :key="'i' + i">
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </draggable>-->
      </div>
      <!-- 预览容器 -->
      <div class="preview-container">
        <el-scrollbar>
          <div class="preview-wrapper">
            <!-- <div class="preview-head">
              <div class="preview-title">{{ title }}</div>
            </div>-->
            <div class="preview-body">
              <div class="default-header">
                <img
                  src="https://imgcdn.hemiao100.com/decoration/4f15bb5b0bbc344e53b841da04055a5.png"
                  alt
                />
              </div>
              <div class="preview-list-group">
                <draggable
                  class="dragArea"
                  :list="previewComponents"
                  group="component"
                  @change="log"
                >
                  <div class="drag-tips" v-if="!previewComponents.length">拖拽组件到此处</div>
                  <div
                    class="preview-list-group-item"
                    @click="selectPreviewItem(i, v.prop)"
                    :class="{
                      active: activePreviewIndex === i,
                      'contact-us-item': v.component === 'contact-us'
                    }"
                    v-for="(v, i) in previewComponents"
                    :key="i"
                  >
                    <component
                      :is="v.component"
                      @add="handleAddZone"
                      @remove="handleRemoveZone"
                      @change="handleChangeZone"
                      ref="singleComponent"
                      :controls="v.component === 'video'"
                      v-bind="v.prop"
                    ></component>
                    <div class="widget" @click="deleteCurrentComponent(i)">
                      <span class="widget-label">{{ v.label }}</span>
                      <span class="widget-icon hmicon icon-shanchu1"></span>
                    </div>
                  </div>
                </draggable>
                <div class="footer">
                  <img
                    src="https://imgcdn.hemiao100.com/decoration/ecacb0f3dfd16225fa1c9097a8de216.png"
                    alt
                  />
                </div>
              </div>
              <div class="preview-height-tag">
                <span class="preview-height-tag-text">iPhone 8手机高度</span>
              </div>
            </div>
            <!-- <tab-bar :tabBarList="tabBarList"></tab-bar> -->
          </div>
        </el-scrollbar>
      </div>
      <!-- 设置项容器 -->
      <div class="options-container">
        <!-- 全局设置 -->
        <div class="page-setting" v-if="showPageSetting">
          <div class="page-header">
            <div class="title">页面设置</div>
            <div class="tips">底部栏图标最多显示5个图标，不可少于3个图标，图标风格需保持统一，建议尺寸40x40像素</div>
            <div>
              <div class="sub-title">顶部栏设置</div>
              <div class="flex item-center">
                <span class="mr10">页面名称</span>
                <el-input class="flex-1" size="small" v-model="title" placeholder="顶部栏标题"></el-input>
              </div>
            </div>
          </div>
          <!-- <div class="page-footer">
            <div class="sub-title">底部栏设置</div>
            <ul class="tabbar-setting">
              <draggable :list="tabBarList">
                <li class="tabbar-setting-item move" v-for="(v, i) in tabBarList" :key="i">
                  <div class="delete-tab" v-if="v.custom && i >= 4" @click="deleteCurrentTabbar(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="flex item-center mb10">
                    <div class="mr10">名称</div>
                    <el-input v-model="v.hrefName" size="small"></el-input>
                    <div class="flex-1 flex flex-end">
                      <el-switch
                        :width="30"
                        v-model="v.open"
                        v-if="v.custom"
                        active-color="#13ce66"
                        :active-value="true"
                        :inactive-value="false"
                      ></el-switch>
                    </div>
                  </div>
                  <div class="mb10">
                    <div class="flex item-center">
                      <div class="mr10">链接</div>
                      <el-select
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-model="v.hrefAddress"
                        v-if="!v.groupGoods.groupId"
                        @change="selectTabBarGroup($event, i)"
                        :disabled="
                          !v.custom ||
                            v.hrefAddress === '/pages/category/category'
                        "
                        style="width: 200px"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseTabBarGroup(i)"
                          type="success"
                        >{{ v.groupGoods.groupName }}</el-tag>
                      </div>
                    </div>
                  </div>
                  <div class="navbar-icon flex">
                    <div class="un-selected flex item-center">
                      <span class="mr10">选中</span>
                      <div
                        class="icon-wrapper"
                        :class="{ 'no-bg': !v.selectedIconpath }"
                        @click="changeIcon(i, 'selectedIconpath')"
                      >
                        <img :src="v.selectedIconpath" v-if="v.selectedIconpath" alt="导航图" />
                        <div class="change-icon">{{ v.selectedIconpath ? "更换图标" : "添加图标" }}</div>
                      </div>
                    </div>
                    <div class="selected flex item-center">
                      <span class="mr10">未选中</span>
                      <div
                        class="icon-wrapper"
                        :class="{ 'no-bg': !v.iconPath }"
                        @click="changeIcon(i, 'iconPath')"
                      >
                        <img :src="v.iconPath" v-if="v.iconPath" alt="导航图" />
                        <div class="change-icon">{{ v.iconPath ? "更换图标" : "添加图标" }}图标</div>
                      </div>
                    </div>
                  </div>
                </li>
              </draggable>
            </ul>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addTabBarList"
                plain
                :disabled="tabBarList && tabBarList.length >= 5"
                size="small"
                class="w100"
              >添加导航</el-button>
            </div>
          </div>-->
        </div>
        <!-- 单个组件设置 -->
        <div class="component-setting" v-if="!showPageSetting">
          <!-- 搜索框设置 -->
          <div class="search-setting" v-if="currentProp && currentProp.name === 'search'">
            <div class="p20">
              <div class="title">商品搜索</div>
              <div class="tips">搜索框默认展示第一个热词，其他搜索词将以标签形式显示在收缩页中</div>
              <div class>
                <div>
                  <span class="mr10">选择模板</span>
                  <span class="sub-title temp">{{ currentProp.radius ? "圆形" : "方形" }}搜索框</span>
                </div>
                <div class="item-setting">
                  <el-radio-group v-model="currentProp.radius">
                    <el-radio :label="false">
                      <div class="shape square" :class="{ active: !currentProp.radius }">
                        <div class="content"></div>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div class="shape radius" :class="{ active: currentProp.radius }">
                        <div class="content"></div>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="have-bg-wrapper">
              <ul class="card-list">
                <li class="card-list-item" v-for="(v, i) in currentProp.hotWordList" :key="i">
                  <el-input
                    max="15"
                    class="w100"
                    @input="setPlaceholder"
                    v-model="v.word"
                    size="small"
                    placeholder="请输入热词,最多15个字"
                  ></el-input>
                  <div class="card-item-delete" @click="deleteCardList(i, 'hotWordList')">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                </li>
              </ul>
              <el-button
                type="primary"
                @click="addHotWord"
                plain
                :disabled="currentProp.hotWordList.length >= 5"
                size="small"
                class="w100"
              >添加热词</el-button>
            </div>
            <ul class="other-setting p20">
              <li class="flex item-center">
                <span class="mr20">框体高度</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="28"
                    :max="50"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.height"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  v-model="currentProp.wrapperBackGround"
                  size="mini"
                  :predefine="predefine"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">框体颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.background"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">文本颜色</span>
                <el-color-picker :predefine="predefine" v-model="currentProp.color" size="mini"></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 客服设置 -->
          <div class="search-setting" v-if="currentProp && currentProp.name === 'contact-us'">
            <div class="p20">
              <div class="title">在线咨询</div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="link">微信客服</el-radio>
                <el-radio label="mobile">电话</el-radio>
                <el-radio label="picture">图片</el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <span class="form-item-tip" v-if="currentProp.type === 'link'">请到小程序后台进行客服号绑定</span>
              <span class="form-item-tip" v-if="currentProp.type === 'picture'">上传图片建议600x600像素</span>
              <el-input
                v-if="currentProp.type === 'mobile'"
                class="w100"
                v-model="currentProp.url"
                size="small"
                min="11"
                max="11"
                placeholder="请输入手机号"
              ></el-input>
              <el-button
                v-if="currentProp.type === 'picture'"
                type="primary"
                plain
                class="w100"
                size="small"
                @click="setConcatImg"
              >上传图片</el-button>
              <div class="mt20">
                <img :src="currentProp.url" alt v-if="currentProp.type === 'picture'" />
              </div>
            </div>
          </div>
          <!-- 商品分类 -->
          <div class="goods-setting" v-if="currentProp && currentProp.name === 'tabs'">
            <div class="p20">
              <div class="title">商品分类</div>
              <div class="tips">添加商品分类，并往分类下添加分组商品</div>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.tabList">
              <div class="tabbar-setting-item" v-for="(v, i) in currentProp.tabList" :key="i">
                <div class="delete-tab" @click="deleteCurrentTabs(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div>
                  <div class="flex flex-between mb20">
                    <el-input
                      class="flex-1 mr20"
                      size="small"
                      v-model="v.tabTitle"
                      placeholder="请输入分类名称"
                    ></el-input>
                    <el-button size="small" type="primary" @click="addTabsGroupGoods(i)">添加分组商品</el-button>
                  </div>
                  <div class="flex item-center" v-if="v.groupGoods.groupId">
                    <span>分组：</span>
                    <el-tag
                      closable
                      @close="handleCloseTabsGroup(i)"
                      type="success"
                    >{{ v.groupGoods.groupName }}</el-tag>
                  </div>
                </div>
              </div>
            </draggable>
            <div class="have-bg-wrapper">
              <el-button type="primary" @click="addTabNav" plain size="small" class="w100">添加分类标题</el-button>
            </div>
            <ul class="other-setting p20 border-bottom">
              <li class="tips">注：标题布局仅在标题未超出屏幕时生效</li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题布局</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.layout">
                    <el-radio label="flex-start">居左</el-radio>
                    <el-radio label="flex-center">居中</el-radio>
                    <el-radio label="flex-between">分散</el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">选中分类</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.type">
                    <el-radio label="text">高亮</el-radio>
                    <el-radio label="line">标线</el-radio>
                    <el-radio label="button">按钮</el-radio>
                  </el-radio-group>
                </div>
              </li>
            </ul>
            <!-- <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">
                    {{ currentProp.borderRadius ? "直角" : "圆角" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">
                    {{ currentProp.titleBold ? "加粗体" : "常规体" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li
                class="flex flex-between item-center"
                v-if="!currentProp.isSwiper"
              >
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品描述</span>
                  <span class="sub-title temp">
                    {{ currentProp.showSubTitle ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSubTitle"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品价格</span>
                  <span class="sub-title temp">
                    {{ currentProp.showPrice ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showPrice"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品角标</span>
                  <span class="sub-title temp">
                    {{ currentProp.showLogo ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showLogo"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
            </ul>
            <div class="p20">
              <el-radio-group
                v-model="currentProp.logoType"
                v-if="currentProp.showLogo"
              >
                <el-radio label="HOT"></el-radio>
                <el-radio label="NEW"></el-radio>
                <el-radio label="秒杀"></el-radio>
                <el-radio label="自定义"></el-radio>
              </el-radio-group>
              <div v-if="currentProp.logoType === '自定义'"><span class="tips">上传图片建议尺寸120x120像素</span></div>
              <div
                class="icon-wrapper"
                v-if="currentProp.logoType === '自定义'"
                :class="{ 'no-bg': !currentProp.logoUrl }"
                @click="changeLogoUrl()"
              >
                <img
                  :src="currentProp.logoUrl"
                  v-if="currentProp.logoUrl"
                  alt="图片广告"
                />
                <div class="change-icon">
                  {{ currentProp.logoUrl ? "更换图片" : "添加图片" }}
                </div>
              </div>
            </div>-->
          </div>
          <!-- 视频设置 -->
          <div class="video-setting" v-if="currentProp && currentProp.name === 'video'">
            <div class="p20">
              <div class="title">视频</div>
              <span class="tips">系统视频仅支持mp4格式的视频,添加成功后会自动播放；腾讯视频需要添加腾讯视频视频id</span>
            </div>
            <div class="p20">
              <el-radio-group v-model="currentProp.type" @change="currentProp.src = ''">
                <el-radio label="origin">系统视频</el-radio>
                <el-radio label="txv">腾讯视频</el-radio>
              </el-radio-group>
            </div>
            <div class="link-wrapper" v-if="currentProp.type === 'txv'">
              <a
                style="color:#2d8cf0;"
                href="https://www.yuque.com/docs/share/ebc783de-b8fb-46f6-8f32-0c0ad19705d8?#"
                target="_blank"
              >如何获取腾讯视频id?</a>
            </div>
            <div class="have-bg-wrapper">
              <el-input
                v-model="currentProp.src"
                class="w100"
                :placeholder="
                  currentProp.type === 'txv'
                    ? '粘贴腾讯视频视频id'
                    : '粘贴mp4视频地址'
                "
                size="small"
              ></el-input>
            </div>
          </div>
          <!-- 辅助分割 -->
          <div
            class="deiding-line-setting"
            v-if="currentProp && currentProp.name === 'dividing-line'"
          >
            <div class="page-header">
              <div class="title">辅助分割</div>
              <span class="tips">可以选择辅助空白或者辅助线，辅助空白颜色不可调整，辅助线高度不可调整</span>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">分割类型</span>
                  <span class="sub-title temp">{{ currentProp.line ? "辅助线" : "辅助空白" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.line">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.line }"
                      >
                        <span class="hmicon icon-fengexian-mian"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.line }"
                      >
                        <span class="hmicon icon-fengexian-xian"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex item-center" v-if="!currentProp.line">
                <span class="mr20">空白高度</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="10"
                    :max="100"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.blankHeight"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between" v-else>
                <span class="mr20">辅助线颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.borderColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 公告 -->
          <div class="notice-setting" v-if="currentProp && currentProp.name === 'notice'">
            <div class="page-header">
              <div class="mb20">
                <div class="title">公告</div>
                <span class="tips">请填写内容，如果内容过长，将会在手机上滚动显示</span>
              </div>
              <div class="flex">
                <span class="sub-title mr10">公告</span>
                <el-input class="flex-1" size="small" type="textarea" v-model="currentProp.text"></el-input>
              </div>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between">
                <span class="mr20">文字颜色</span>
                <el-color-picker :predefine="predefine" v-model="currentProp.color" size="mini"></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 富文本编辑器 -->
          <div class="rich-text-setting" v-if="currentProp && currentProp.name === 'rich-text'">
            <div class="p20">
              <div class="title">富文本</div>
              <div class="tips">
                点击下方编辑富文本，你可以对文字进行
                <b>加粗</b>、
                <i>斜体</i>、
                <u>下划线</u>、
                <s>删除线</s>、文字
                <span style="color: #e2005d">颜色</span>、
                <span style="background: #e2005d; color: #fff">背景色</span>，以及
                <span class="title">字号大小</span>进行简单排版
              </div>
            </div>
            <div class="have-bg-wrapper">
              <hm-rich-editor v-model="currentProp.content" />
            </div>
          </div>
          <!-- 标题文本设置 -->
          <div class="title-text-setting" v-if="currentProp && currentProp.name === 'title-text'">
            <div class="page-header">
              <div class="title">标题文本</div>
              <div class="flex item-center mb20">
                <span class="mr10">标题内容</span>
                <el-input
                  class="flex-1"
                  type="text"
                  size="small"
                  placeholder="请输入标题"
                  v-model="currentProp.title"
                ></el-input>
              </div>
              <div class="flex item-center">
                <span class="mr10">描述内容</span>
                <el-input
                  class="flex-1"
                  type="textarea"
                  maxlength="100"
                  size="small"
                  placeholder="请输入描述,最多100字"
                  v-model="currentProp.subTitle"
                ></el-input>
              </div>
            </div>
            <ul class="other-setting">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{ currentProp.titleBold ? "加粗体" : "常规体" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">描述粗细</span>
                  <span class="sub-title temp">{{ currentProp.subTitleBold ? "加粗体" : "常规体" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.subTitleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.subTitleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.subTitleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.titleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">描述颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.subTitleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
            <div class="p20">
              <div class="flex flex-between mb20">
                <div>
                  <span>复制</span>
                  <span class="tips">（复制标题到剪贴板）</span>
                </div>

                <el-switch
                  v-model="currentProp.isShowCopyBtn"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div class="flex flex-between mb20">
                <span>查看更多</span>
                <el-switch
                  v-model="currentProp.isShowMore"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div class="flex item-center" style="padding: 10px 0">
                <span class="mr10">链接类型</span>
                <el-radio-group
                  style="border: none"
                  class="flex-1"
                  v-model="currentProp.pageType"
                  @change="openGoodsSelectSingle"
                >
                  <el-radio label="page" style="marginRight: 20px">页面</el-radio>
                  <!-- <el-radio label="goods" style="marginRight: 20px">商品</el-radio>
                  <el-radio label="brand">品牌</el-radio>-->
                </el-radio-group>
              </div>
              <div class="flex item-center" v-if="currentProp.pageType === 'page'">
                <span class="mr10">链接</span>
                <el-select
                  class="flex-1"
                  size="small"
                  clearable
                  v-if="!currentProp.groupGoods.groupId"
                  placeholder="选择页面"
                  v-model="currentProp.hrefAddress"
                  @change="selectGroup"
                  filterable
                >
                  <el-option
                    v-for="(item, i) in microShopRouteList"
                    :key="i"
                    :label="item.hrefName"
                    :value="item.hrefAddress"
                  ></el-option>
                </el-select>
                <div class="flex item-center" v-if="currentProp.groupGoods.groupId">
                  <span>分组：</span>
                  <el-tag
                    closable
                    @close="handleCloseGroup"
                    type="success"
                  >{{ currentProp.groupGoods.groupName }}</el-tag>
                </div>
              </div>
              <div
                class="flex item-center"
                v-if="
                  currentProp.pageType === 'goods' &&
                    currentProp.goodsInfo &&
                    currentProp.goodsInfo.wxshopSpuName
                "
              >
                <span class="mr10">商品</span>
                <el-tag
                  closable
                  @close="handleCloseSingle"
                  type="success"
                >{{ currentProp.goodsInfo.wxshopSpuName }}</el-tag>
              </div>
              <div
                class="flex item-center"
                v-if="
                  currentProp.pageType === 'brand' &&
                    currentProp.brandInfo &&
                    currentProp.brandInfo.brandName
                "
              >
                <span class="mr10">品牌</span>
                <el-tag
                  closable
                  @close="handleCloseSingle"
                  type="success"
                >{{ currentProp.brandInfo.brandName }}</el-tag>
              </div>
            </div>
          </div>          
          <!-- 图片广告 -->
          <div
            class="image-ad-setting"
            v-if="currentProp && currentProp.name === 'image-ad-selection'"
          >
            <div class="p20">
              <div class="title">图片广告</div>
              <div class="tips">最多添加6个广告，鼠标拖拽调整广告顺序，建议尺寸1500*720像素</div>
              <div class="item-setting">
                <div>
                  选择模板
                  <span v-if="currentProp.type === '1'">轮播海报</span>
                  <span v-if="currentProp.type === '2'">一行一张</span>
                  <span v-if="currentProp.type === '3'">两列轮播</span>
                </div>
                <el-radio-group
                  v-model="currentProp.type"
                  class="flex"
                  @change="switchImageAdTemp(currentProp.type)"
                >
                  <el-radio label="1">
                    <div class="shape no-swiper" :class="{ active: currentProp.type === '1' }">
                      <div class="content"></div>
                    </div>
                  </el-radio>
                  <el-radio label="2">
                    <div class="shape swiper" :class="{ active: currentProp.type === '2' }">
                      <div class="content"></div>
                    </div>
                  </el-radio>
                  <el-radio label="3">
                    <div
                      class="shape double-swiper flex flex-between"
                      :class="{ active: currentProp.type === '3' }"
                    >
                      <div class="content flex"></div>
                      <div class="content flex"></div>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="have-bg-wrapper">
              <div class="item-setting image-ad-selection-upload" v-if="currentProp.type === '3'">
                <el-radio-group v-model="imgAdSelectionUpLoadType" class="flex">
                  <el-radio label="leftImgList" style="margin: 0">
                    <div
                      class="context flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'leftImgList'
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'leftImgList'
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                  <el-radio label="rightImgList" style="margin: 0">
                    <div
                      class="context flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'rightImgList'
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'rightImgList'
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
              <draggable
                class="tabbar-setting"
                :list="currentProp.imgList"
                v-if="currentProp.type !== '3'"
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.imgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="icon-wrapper" :class="{ 'no-bg': !v.src }" @click="changeImageAd(i)">
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">{{ v.src ? "更换图片" : "添加图片" }}</div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'imgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <!-- <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>-->
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'imgList')"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('imgList', i)"
                          type="success"
                        >{{ v.groupGoods.groupName }}</el-tag>
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.goodsInfo.wxshopSpuName }}</el-tag>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.brandInfo.brandName }}</el-tag>
                    </div>
                  </div>
                </div>
              </draggable>
              <draggable
                class="tabbar-setting"
                :list="currentProp.leftImgList"
                v-if="
                  currentProp.type === '3' &&
                    imgAdSelectionUpLoadType === 'leftImgList'
                "
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.leftImgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="icon-wrapper" :class="{ 'no-bg': !v.src }" @click="changeImageAd(i)">
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">{{ v.src ? "更换图片" : "添加图片" }}</div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'leftImgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <!-- <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>-->
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'leftImgList')"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('leftImgList', i)"
                          type="success"
                        >{{ v.groupGoods.groupName }}</el-tag>
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.goodsInfo.wxshopSpuName }}</el-tag>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.brandInfo.brandName }}</el-tag>
                    </div>
                  </div>
                </div>
              </draggable>
              <draggable
                class="tabbar-setting"
                :list="currentProp.rightImgList"
                v-if="
                  currentProp.type === '3' &&
                    imgAdSelectionUpLoadType === 'rightImgList'
                "
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.rightImgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="icon-wrapper" :class="{ 'no-bg': !v.src }" @click="changeImageAd(i)">
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">{{ v.src ? "更换图片" : "添加图片" }}</div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'rightImgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <!-- <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>-->
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'rightImgList')"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('rightImgList', i)"
                          type="success"
                        >{{ v.groupGoods.groupName }}</el-tag>
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.goodsInfo.wxshopSpuName }}</el-tag>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.brandInfo.brandName }}</el-tag>
                    </div>
                  </div>
                </div>
              </draggable>
              <el-button
                :disabled="
                  (currentProp.type !== '3' &&
                    currentProp.imgList &&
                    currentProp.imgList.length >= 5) ||
                    (currentProp.type === '3' &&
                      currentProp.leftImgList &&
                      currentProp.leftImgList.length >= 5 &&
                      imgAdSelectionUpLoadType === 'leftImgList') ||
                    (currentProp.type === '3' &&
                      currentProp.rightImgList &&
                      currentProp.rightImgList.length >= 5 &&
                      imgAdSelectionUpLoadType === 'rightImgList')
                "
                type="primary"
                plain
                size="small"
                class="w100"
                @click="addImageAd"
              >添加背景图</el-button>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{ !currentProp.borderRadius ? "直角" : "圆角" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.margin"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center" v-if="!currentProp.isSwiper">
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
          </div>
          <!-- 热销活动 -->
          <div
            class="goods-setting"
            v-if="currentProp && currentProp.name === 'hot'"
          >
            <div class="p20">
              <div class="title">热销活动</div>
              <div class="tips">添加热销活动分类，并往分类下添加分组商品</div>
            </div>

            <div
                class="icon-wrapper"
                :class="{ 'no-bg': !currentProp.hotImg }"
                style="margin: 0 20px"
                @click="changeHotImageAd()"
            >
              <img :src="currentProp.hotImg" class="img" v-if="currentProp.hotImg" alt="图片广告" />
              <div class="change-icon">
                {{ currentProp.hotImg ? "更换图片" : "添加图片" }}
              </div>
            </div>

            <draggable class="tabbar-setting" :list="currentProp.hotList">
              <div
                class="tabbar-setting-item"
                v-for="(v, i) in currentProp.hotList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentHot(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div>
                  <div class="flex flex-between mb20">
                    <el-input
                      class="flex-1 mr20"
                      size="small"
                      v-model="v.hotTitle"
                      placeholder="请输入分类名称"
                    ></el-input>
                    <el-button
                      size="small"
                      type="primary"
                      @click="addHotGroupGoods(i)"
                      >添加分组商品</el-button
                    >
                  </div>
                  <div class="flex item-center">
                    <span>副标题：</span>
                    <el-input
                        class="flex-1 mr20"
                        size="small"
                        v-model="v.hotAssistantTitle"
                        placeholder="请输入副分类名称"
                    ></el-input>
                  </div>
                  <div class="flex item-center flex-wrap" v-if="v.groupGoods.length > 0">
                    <span>分组：</span>
                    <el-tag
                      style="margin-bottom:5px"
                      closable
                      @close="handleCloseHotGroup(i,goodsIndex)"
                      type="success"
                      v-for="(goodsItem,goodsIndex) in v.groupGoods"
                      :key="goodsIndex"
                      >
                      {{ goodsItem.gameName }}
                      </el-tag
                    >
                  </div>
                </div>
              </div>
            </draggable>
            <div class="have-bg-wrapper">
              <el-button
                type="primary"
                @click="addHotNav"
                plain
                size="small"
                class="w100"
                >添加分类标题</el-button
              >
            </div>
            <ul class="other-setting p20 border-bottom">
              <li class="tips">注：标题布局仅在标题未超出屏幕时生效</li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题布局</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.layout">
                    <el-radio label="flex-start">居左</el-radio>
                    <el-radio label="flex-around">居中</el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">选中分类</span>
                </div>
                <div class="flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.type">
                    <el-radio label="text">高亮</el-radio>
                    <el-radio label="underline">标线</el-radio>
                    <el-radio label="button">按钮</el-radio>
                  </el-radio-group>
                </div>
              </li>
            </ul>
          </div>
          <!-- 图片热区 -->
          <div
            class="groupon-setting"
            v-if="currentProp && currentProp.name === 'hotZone'"
          >
            <div class="p20">
              <div class="title">图片热区</div>
              <div class="tips">
                <span style="color: #e50065">点击预览区图片</span
                >，待鼠标变成十字后，在图片上拖拽划分区域以添加链接地址
              </div>
            </div>

            <div class="have-bg-wrapper tabbar-setting">
              <div
                class="hotzone-img-wrapper pointer"
                @click="uploadHotZoneImage"
              >
                <img :src="currentProp.image" alt="plus会员背景" />
                <div class="tip">更换热区图</div>
              </div>
              <div
                class="tabbar-setting-item flex"
                v-for="(v, i) in currentProp.zones"
                :key="i"
              >
                <!-- <div class="delete-tab" @click="handleRemoveZone(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div> -->
                <div class="flex-1" style="width:295px">
                  <div class="flex item-center">
                    <div class="mr10 bold title">热区{{ i + 1 }}</div>
                  </div>
                  <div class="flex item-center" style="padding: 10px 0">
                    <span class="mr10">类型</span>
                    <el-radio-group
                      v-model="v.pageType"
                      class="flex-1"
                      style="line-height:18px"
                      @change="openGoodsSelect(v, i, 'zones')"
                    >
                      <el-radio label="page">页面</el-radio>
                      <el-radio label="goods">商品</el-radio>
                      <el-radio label="brand">品牌</el-radio>
                      <el-radio label="mp">小程序</el-radio>
                      <el-radio label="coupon">优惠券</el-radio>
                      <el-radio label="qyWeChat">企微客服</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="flex item-center" v-if="v.pageType === 'page'">
                    <span class="mr10">链接</span>
                    <el-select
                      class="flex-1"
                      size="small"
                      clearable
                      placeholder="选择页面"
                      v-if="!v.groupGoods.groupId"
                      v-model="v.hrefAddress"
                      @change="selectGroup($event, i, 'zones')"
                      allow-create
                      filterable
                    >
                      <el-option
                        v-for="(item, index) in microShopRouteList"
                        :key="index"
                        :label="item.hrefName"
                        :value="item.hrefAddress"
                      ></el-option>
                    </el-select>
                    <div class="flex item-center" v-if="v.groupGoods.groupId">
                      <span>分组：</span>
                      <el-tag
                        closable
                        @close="handleCloseGroup('zones', i)"
                        type="success"
                        >{{ v.groupGoods.groupName }}</el-tag
                      >
                    </div>
                  </div>
                  <div
                    class="flex item-center"
                    v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                  >
                    <span class="mr10">商品</span>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                    >
                  </div>
                  <div
                    class="flex item-center"
                    v-if="
                      v.pageType === 'brand' &&
                        v.brandInfo &&
                        v.brandInfo.brandName
                    "
                  >
                    <span class="mr10">品牌</span>
                    <el-tag
                      closable
                      @close="handleClose(v, i)"
                      type="success"
                      >{{ v.brandInfo.brandName }}</el-tag
                    >
                  </div>
                  <template v-if="v.pageType === 'mp'">
                    <div class="flex item-center mb20">
                      <span class="mr10">appid</span>
                      <el-input
                        class="flex-1"
                        size="small"
                        v-model="v.appid"
                        type="text"
                        placeholder="请输入appid"
                      ></el-input>
                    </div>
                    <div class="flex item-center">
                      <span style="width: 34px" class="mr10">链接</span>
                      <el-input
                        class="flex-1"
                        v-model="v.hrefAddress"
                        size="small"
                        type="text"
                        placeholder="请输入链接"
                      ></el-input>
                    </div>
                  </template>
                  <template v-if="v.pageType === 'qyWeChat'">
                    <div class="flex item-center">
                      <span style="width: 34px" class="mr10">链接</span>
                      <el-input
                        class="flex-1"
                        v-model="v.src"
                        size="small"
                        type="text"
                        placeholder="请输入链接"
                      ></el-input>
                    </div>
                  </template>
                  <template v-if="v.pageType === 'coupon'">
                    <div class="have-bg-wrapper">
                      <el-button
                        type="primary"
                        @click="addCoupon('HotZone')"
                        plain
                        size="small"
                        class="w100"
                        >添加优惠券</el-button
                      >
                    </div>
                    <div class="coupon-list">
                      <div
                        class="coupon-item flex"
                        v-for="(item, index) in v.couponList"
                        :key="index"
                      >
                        <div
                          class="delete-tab"
                          @click="deleteCurrentCoupon(i, index)"
                        >
                          <span class="hmicon icon-guanbi1"></span>
                        </div>
                        <div
                          class="price-wrapper flex flex-column flex-center item-center"
                          :style="{
                            background: storeStyle.baseColor
                          }"
                        >
                          <div class="price" v-if="!item.discount">
                            {{ item.account }}
                          </div>
                          <div class="discount" v-if="item.discount">
                            {{ item.discount }}
                          </div>
                          <div>
                            <div class="limit">满{{ item.levelMin }}使用</div>
                          </div>
                        </div>
                        <div class="flex-1 info flex flex-column flex-center">
                          <div class="name">{{ item.name }}</div>
                          <div class="valid-time">
                            有效期：{{ item.dateTime }}
                          </div>
                          <div>
                            <button
                              :style="{ background: storeStyle.baseColor }"
                              class="btn round"
                            >
                              立即领取
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- 猜你喜欢 -->
          <div
            class="goods-setting"
            v-if="currentProp && currentProp.name === 'guess-you-like'"
          >
            <div class="p20">
              <div class="title">猜你喜欢</div>
              <div class="tips">根据客户购买商品动态推荐客户商品</div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div class="item-setting template-setting flex">
                <el-radio-group v-model="currentProp.goodShowType">
                  <el-radio label="big">
                    <div
                      style="height: 60px"
                      class="shape two-column flex"
                      :class="{ active: currentProp.goodShowType === 'big' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9d8ee587-635e-4dc4-8aa6-c678a07f25bf.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="twoColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'twoColumn'
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/481b7566-8606-4147-817f-d3e27c56c493.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="threeColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'threeColumn'
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/69a14a701832cdb47f321eb847d04ef.png"
                        alt="一行3列"
                      />
                    </div>
                  </el-radio>
                  <!-- <el-radio label="scroll">
                    <div
                      style="height: 60px"
                      class="shape four-column flex"
                      :class="{ active: currentProp.goodShowType === 'scroll' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/415fc147-4b32-4c39-b022-ac4e61ba41e4.png"
                        alt
                      />
                    </div>
                  </el-radio> -->
                </el-radio-group>
              </div>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>
            <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{
                    !currentProp.borderRadius ? "直角" : "圆角"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{
                    currentProp.titleBold ? "加粗体" : "常规体"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li
                class="flex flex-between item-center"
                v-if="!currentProp.isSwiper"
              >
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品描述</span>
                  <span class="sub-title temp">{{
                    currentProp.showSubTitle ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSubTitle"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品价格</span>
                  <span class="sub-title temp">{{
                    currentProp.showPrice ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showPrice"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <!-- <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">购买按钮</span>
                  <span class="sub-title temp">
                    {{ currentProp.showCart ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showCart"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>-->
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品销量</span>
                  <span class="sub-title temp">{{
                    currentProp.showSaleNum ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSaleNum"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品角标</span>
                  <span class="sub-title temp">{{
                    currentProp.showLogo ? "显示" : "隐藏"
                  }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showLogo"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
            </ul>
            <div class="p20">
              <el-radio-group
                v-model="currentProp.logoType"
                v-if="currentProp.showLogo"
              >
                <el-radio label="HOT"></el-radio>
                <el-radio label="NEW"></el-radio>
                <el-radio label="秒杀"></el-radio>
                <el-radio label="自定义"></el-radio>
              </el-radio-group>
              <div v-if="currentProp.logoType === '自定义'">
                <span class="tips">上传图片建议尺寸120x120像素</span>
              </div>
              <div
                class="icon-wrapper"
                v-if="currentProp.logoType === '自定义'"
                :class="{ 'no-bg': !currentProp.logoUrl }"
                @click="changeLogoUrl()"
              >
                <img
                  :src="currentProp.logoUrl"
                  v-if="currentProp.logoUrl"
                  alt="图片广告"
                />
                <div class="change-icon">
                  {{ currentProp.logoUrl ? "更换图片" : "添加图片" }}
                </div>
              </div>
            </div>
          </div>
          <!-- 图文导航 -->
          <div class="image-ad-setting" v-if="currentProp && currentProp.name === 'image-text-nav'">
            <div class="p20">
              <div class="title">图文导航</div>
              <div class="tips">不能少于3个导航，最多添加5个导航，拖动选中的导航可对其进行排序。注：上传图片时风格尺寸需要保持统一，建议尺寸90x90像素</div>
            </div>
            <div class="have-bg-wrapper">
              <draggable class="tabbar-setting" :list="currentProp.imageTextNavList">
                <div
                  class="tabbar-setting-item"
                  v-for="(v, i) in currentProp.imageTextNavList"
                  :key="i"
                >
                  <div
                    class="delete-tab"
                    v-if="
                      currentProp.imageTextNavList &&
                        currentProp.imageTextNavList.length > 3
                    "
                    @click="deleteCurrentImageTextNav(i)"
                  >
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div class="flex">
                    <div class="navbar-icon flex">
                      <div class="un-selected flex">
                        <div
                          class="icon-wrapper"
                          :class="{ 'no-bg': !v.src }"
                          @click="changeImageTextNav(i)"
                        >
                          <img :src="v.src" v-if="v.src" alt="导航图" />
                          <div class="change-icon">{{ v.src ? "更换图标" : "添加图标" }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <div class="flex item-center mb10">
                        <div class="mr10">标题</div>
                        <el-input class="flex-1" v-model="v.title" size="small"></el-input>
                      </div>
                      <div class="flex item-center" style="padding: 10px 0">
                        <span class="mr10">链接类型</span>
                        <el-radio-group
                          v-model="v.pageType"
                          class="flex-1"
                          @change="openGoodsSelect(v, i, 'imageTextNavList')"
                        >
                          <el-radio label="page">页面</el-radio>
                          <!-- <el-radio label="goods">商品</el-radio>
                          <el-radio label="brand">品牌</el-radio>-->
                        </el-radio-group>
                      </div>
                      <div class="flex item-center" v-if="v.pageType === 'page'">
                        <span class="mr10">链接</span>
                        <el-select
                          class="flex-1"
                          size="small"
                          clearable
                          placeholder="选择页面"
                          v-model="v.hrefAddress"
                          v-if="!v.groupGoods.groupId"
                          @change="selectGroup($event, i, 'imageTextNavList')"
                          filterable
                        >
                          <el-option
                            v-for="(item, index) in microShopRouteList"
                            :key="index"
                            :label="item.hrefName"
                            :value="item.hrefAddress"
                          ></el-option>
                        </el-select>
                        <div class="flex item-center" v-if="v.groupGoods.groupId">
                          <span>分组：</span>
                          <el-tag
                            closable
                            @close="handleCloseGroup('imageTextNavList', i)"
                            type="success"
                          >{{ v.groupGoods.groupName }}</el-tag>
                        </div>
                      </div>
                      <div
                        class="flex item-center"
                        v-if="
                          v.pageType === 'goods' && v.goodsInfo.wxshopSpuName
                        "
                      >
                        <span class="mr10">商品</span>
                        <el-tag
                          closable
                          @close="handleClose(v, i)"
                          type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag>
                      </div>
                      <div
                        class="flex item-center"
                        v-if="
                          v.pageType === 'brand' &&
                            v.brandInfo &&
                            v.brandInfo.brandName
                        "
                      >
                        <span class="mr10">品牌</span>
                        <el-tag
                          closable
                          @close="handleClose(v, i)"
                          type="success"
                        >{{ v.brandInfo.brandName }}</el-tag>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
              <el-button
                type="primary"
                @click="addImageTextNav"
                plain
                :disabled="
                  currentProp.imageTextNavList &&
                    currentProp.imageTextNavList.length >= 5
                "
                size="small"
                class="w100"
              >添加导航</el-button>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  v-model="currentProp.backgroundColor"
                  size="mini"
                  :predefine="predefine"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">文字颜色</span>
                <el-color-picker :predefine="predefine" v-model="currentProp.color" size="mini"></el-color-picker>
              </li>
            </ul>
          </div>
          <!-- 魔方 -->
          <div class="cube-setting" v-if="currentProp && currentProp.name === 'cube'">
            <div class="p20">
              <div class="title">魔方</div>
              <div class="tips">选定布局区域，在下方添加图片，建议添加比例一致的图片，建议尺寸360x360像素</div>
              <div class="other-setting">
                <div>
                  <span class="mr20">选择模板</span>
                  <span class="sub-title temp">
                    {{
                    currentProp.permutation === 2
                    ? "一行两列"
                    : currentProp.permutation === 3
                    ? "一行三列"
                    : "一行四列"
                    }}
                  </span>
                </div>
                <div class="item-setting flex">
                  <el-radio-group v-model="currentProp.permutation">
                    <el-radio :label="2">
                      <div
                        class="shape two-column flex"
                        :class="{ active: currentProp.permutation === 2 }"
                      >
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                      </div>
                    </el-radio>
                    <el-radio :label="3">
                      <div
                        class="shape three-column flex"
                        :class="{ active: currentProp.permutation === 3 }"
                      >
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                      </div>
                    </el-radio>
                    <el-radio :label="4">
                      <div
                        class="shape four-column flex"
                        :class="{ active: currentProp.permutation === 4 }"
                      >
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                        <div class="column flex-1"></div>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="have-bg-wrapper" style="padding: 0">
              <draggable class="tabbar-setting o" :list="currentProp.cubeList">
                <div
                  class="tabbar-setting-item flex move"
                  v-for="(v, i) in currentProp.cubeList"
                  :key="i"
                >
                  <div class="icon-wrapper" :class="{ 'no-bg': !v.src }" @click="changeCube(i)">
                    <img class="w100" :src="v.src" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">{{ v.src ? "更换图片" : "添加图片" }}</div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">链接类型</span>
                      <el-radio-group
                        class="flex-1"
                        v-model="v.pageType"
                        @change="openGoodsSelect(v, i, 'cubeList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <!-- <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>-->
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择页面"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'cubeList')"
                        v-if="!v.groupGoods.groupId"
                        filterable
                      >
                        <el-option
                          v-for="(item, i) in microShopRouteList"
                          :key="i"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('cubeList', i)"
                          type="success"
                        >{{ v.groupGoods.groupName }}</el-tag>
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.goodsInfo.wxshopSpuName }}</el-tag>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                      >{{ v.brandInfo.brandName }}</el-tag>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <span class="mr20">图片空隙</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.itemMargin"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.margin"
                  ></el-slider>
                </div>
              </li>
            </ul>
          </div>
          <!-- 商品排列 -->
          <div class="goods-setting" v-if="currentProp && currentProp.name === 'goodsList'">
            <div class="p20">
              <div class="title">商品排列</div>
              <div class="tips">直接上传已上架商品（商品分组则上传已分类商品）商品分组最多添加7组分类</div>
              <div>
                <span class="mr20">选择模板</span>
                <span class="sub-title temp">{{ goodsType }}</span>
              </div>
              <div class="item-setting template-setting flex">
                <el-radio-group v-model="currentProp.goodShowType">
                  <el-radio label="big">
                    <div
                      style="height: 60px"
                      class="shape two-column flex"
                      :class="{ active: currentProp.goodShowType === 'big' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9d8ee587-635e-4dc4-8aa6-c678a07f25bf.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="twoColumn">
                    <div
                      style="height: 60px"
                      class="shape three-column flex"
                      :class="{
                        active: currentProp.goodShowType === 'twoColumn'
                      }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/481b7566-8606-4147-817f-d3e27c56c493.png"
                        alt
                      />
                    </div>
                  </el-radio>
                  <el-radio label="scroll">
                    <div
                      style="height: 60px"
                      class="shape four-column flex"
                      :class="{ active: currentProp.goodShowType === 'scroll' }"
                    >
                      <img
                        class="w100"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/415fc147-4b32-4c39-b022-ac4e61ba41e4.png"
                        alt
                      />
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <draggable class="tabbar-setting" :list="currentProp.goodsList">
              <div
                class="tabbar-setting-item"
                v-show="!v.isMock"
                v-for="(v, i) in currentProp.goodsList"
                :key="i"
              >
                <div class="delete-tab" @click="deleteCurrentGoods(i)">
                  <span class="hmicon icon-guanbi1"></span>
                </div>
                <div class="flex">
                  <div class="img-wrapper mr10">
                    <img :src="v.spuMainPic" alt="logo" style="width: 50px" />
                  </div>
                  <div class="goods-name">{{ v.wxshopSpuName }}</div>
                </div>
              </div>
            </draggable>
            <div class="have-bg-wrapper">
              <el-button type="primary" @click="addGoods" plain size="small" class="w100">添加商品</el-button>
            </div>
            <ul class="other-setting p20 border-bottom">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{ !currentProp.borderRadius ? "直角" : "圆角" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{ currentProp.titleBold ? "加粗体" : "常规体" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </li>
              <li class="flex flex-between item-center" v-if="!currentProp.isSwiper">
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品描述</span>
                  <span class="sub-title temp">{{ currentProp.showSubTitle ? "显示" : "隐藏" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showSubTitle"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品价格</span>
                  <span class="sub-title temp">{{ currentProp.showPrice ? "显示" : "隐藏" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showPrice"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
              <!-- <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">购买按钮</span>
                  <span class="sub-title temp">
                    {{ currentProp.showCart ? "显示" : "隐藏" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showCart"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>-->
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">商品角标</span>
                  <span class="sub-title temp">{{ currentProp.showLogo ? "显示" : "隐藏" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-switch
                    :width="30"
                    v-model="currentProp.showLogo"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </li>
            </ul>
            <div class="p20">
              <el-radio-group v-model="currentProp.logoType" v-if="currentProp.showLogo">
                <el-radio label="HOT"></el-radio>
                <el-radio label="NEW"></el-radio>
                <el-radio label="秒杀"></el-radio>
                <el-radio label="自定义"></el-radio>
              </el-radio-group>
              <div v-if="currentProp.logoType === '自定义'">
                <span class="tips">上传图片建议尺寸120x120像素</span>
              </div>
              <div
                class="icon-wrapper"
                v-if="currentProp.logoType === '自定义'"
                :class="{ 'no-bg': !currentProp.logoUrl }"
                @click="changeLogoUrl()"
              >
                <img :src="currentProp.logoUrl" v-if="currentProp.logoUrl" alt="图片广告" />
                <div class="change-icon">{{ currentProp.logoUrl ? "更换图片" : "添加图片" }}</div>
              </div>
            </div>
          </div>
          <!-- 优惠券 -->
          <div class="coupon-setting" v-if="currentProp && currentProp.name === 'coupon'">
            <div class="p20">
              <div class="title">优惠券</div>
              <div class="tips">最多添加10张优惠券</div>
            </div>
            <div class="item-setting">
              <div>
                选择模板
                <span>
                  {{
                  currentProp.type === "1" ? "样式一" : "样式二"
                  }}
                </span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div class="shape style1" :class="{ active: currentProp.type === '1' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div class="shape style2" :class="{ active: currentProp.type === '2' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button type="primary" @click="addCoupon" plain size="small" class="w100">添加优惠券</el-button>
            </div>
            <div class="settings">
              <div class="flex item-center settings-item">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.title" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.secTitle" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group v-model="currentProp.fillBgType" @change="changeCouponFillType">
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 100px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img :src="currentProp.bg" class="img" v-if="currentProp.bg" alt="填充背景" />
                    <div class="change-icon">{{ currentProp.bg ? "更换背景" : "添加背景" }}</div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker :predefine="predefine" v-model="currentProp.color" size="mini"></el-color-picker>
              </div>
              <div class="settings-item">
                <div class="flex item-center">
                  <div class="label">券颜色</div>
                  <div>
                    <el-radio-group
                      v-model="currentProp.couponColorType"
                      @change="changeCouponColorType"
                    >
                      <el-radio label="default">默认全店风格</el-radio>
                      <el-radio label="custom">自定义</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 100px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.couponColorType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.couponColor"
                    size="mini"
                  ></el-color-picker>
                </div>
              </div>
            </div>
          </div>
          <!-- 拼团 -->
          <div class="groupon-setting" v-if="currentProp && currentProp.name === 'groupon'">
            <div class="p20">
              <div class="title">拼团</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">横条样式</span>
                <span v-if="currentProp.type === '2'">块状样式</span>
                <span v-if="currentProp.type === '3'">横向滑动</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div class="shape style1" :class="{ active: currentProp.type === '1' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div class="shape style2" :class="{ active: currentProp.type === '2' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div class="shape style3" :class="{ active: currentProp.type === '3' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button type="primary" @click="addGroupon" plain size="small" class="w100">添加拼团商品</el-button>
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.title" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.secTitle" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group v-model="currentProp.fillBgType" @change="changeCouponFillType">
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 100px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img :src="currentProp.bg" class="img" v-if="currentProp.bg" alt="填充背景" />
                    <div class="change-icon">{{ currentProp.bg ? "更换背景" : "添加背景" }}</div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker :predefine="predefine" v-model="currentProp.color" size="mini"></el-color-picker>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{ !currentProp.borderRadius ? "直角" : "圆角" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{ currentProp.titleBold ? "加粗体" : "常规体" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 秒杀 -->
          <div class="groupon-setting" v-if="currentProp && currentProp.name === 'seckill'">
            <div class="p20">
              <div class="title">秒杀</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">横条样式</span>
                <span v-if="currentProp.type === '2'">块状样式</span>
                <span v-if="currentProp.type === '3'">横向滑动</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div class="shape style1" :class="{ active: currentProp.type === '1' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div class="shape style2" :class="{ active: currentProp.type === '2' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div class="shape style3" :class="{ active: currentProp.type === '3' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button type="primary" @click="addSeckill" plain size="small" class="w100">添加秒杀商品</el-button>
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.title" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.secTitle" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group v-model="currentProp.fillBgType" @change="changeCouponFillType">
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 100px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img :src="currentProp.bg" class="img" v-if="currentProp.bg" alt="填充背景" />
                    <div class="change-icon">{{ currentProp.bg ? "更换背景" : "添加背景" }}</div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker :predefine="predefine" v-model="currentProp.color" size="mini"></el-color-picker>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{ !currentProp.borderRadius ? "直角" : "圆角" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{ currentProp.titleBold ? "加粗体" : "常规体" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 砍价 -->
          <div class="groupon-setting" v-if="currentProp && currentProp.name === 'bargain'">
            <div class="p20">
              <div class="title">砍价</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">横条样式</span>
                <span v-if="currentProp.type === '2'">块状样式</span>
                <span v-if="currentProp.type === '3'">横向滑动</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div class="shape style1" :class="{ active: currentProp.type === '1' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div class="shape style2" :class="{ active: currentProp.type === '2' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="3">
                  <div class="shape style3" :class="{ active: currentProp.type === '3' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button type="primary" @click="addBargain" plain size="small" class="w100">添加砍价商品</el-button>
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.title" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.secTitle" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item">
                <div class="flex item-center">
                  <div class="label">填充背景</div>
                  <div>
                    <el-radio-group v-model="currentProp.fillBgType" @change="changeCouponFillType">
                      <el-radio label="custom">自定义颜色</el-radio>
                      <el-radio label="bgImage">上传背景图</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div style="margin-left: 100px; margin-top: 10px">
                  <el-color-picker
                    v-if="currentProp.fillBgType === 'custom'"
                    :predefine="predefine"
                    v-model="currentProp.bg"
                    size="mini"
                  ></el-color-picker>
                  <div
                    class="icon-wrapper"
                    v-if="currentProp.fillBgType === 'bgImage'"
                    :class="{ 'no-bg': !currentProp.bg }"
                    @click="changeCouponBg"
                  >
                    <img :src="currentProp.bg" class="img" v-if="currentProp.bg" alt="填充背景" />
                    <div class="change-icon">{{ currentProp.bg ? "更换背景" : "添加背景" }}</div>
                  </div>
                </div>
              </div>
              <div class="settings-item flex flex-between item-center">
                <span class="mr20">文字颜色</span>
                <el-color-picker :predefine="predefine" v-model="currentProp.color" size="mini"></el-color-picker>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{ !currentProp.borderRadius ? "直角" : "圆角" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{ currentProp.titleBold ? "加粗体" : "常规体" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
          <!-- 直播 -->
          <div
            class="groupon-setting live-setting"
            v-if="currentProp && currentProp.name === 'live'"
          >
            <div class="p20">
              <div class="title">直播</div>
            </div>
            <div class="item-setting top">
              <div>
                选择模板
                <span v-if="currentProp.type === '1'">大图</span>
                <span v-if="currentProp.type === '2'">二宫格</span>
              </div>
              <el-radio-group v-model="currentProp.type">
                <el-radio label="1">
                  <div class="shape style1" :class="{ active: currentProp.type === '1' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
                <el-radio label="2">
                  <div class="shape style2" :class="{ active: currentProp.type === '2' }">
                    <div class="content"></div>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="have-bg-wrapper">
              <el-button type="primary" @click="addLiveRoom" plain size="small" class="w100">添加直播间</el-button>
            </div>
            <div class="settings other-setting">
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">模块名称</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.title" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.titleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="flex item-center settings-item title-text-setting">
                <div class="label">副标题</div>
                <div class="flex-1">
                  <el-input size="small" v-model="currentProp.secTitle" placeholder="请输入模块名称"></el-input>
                </div>
                <div>
                  <el-switch
                    :width="30"
                    v-model="currentProp.secTitleVisible"
                    active-color="#13ce66"
                    :active-value="true"
                    :inactive-value="false"
                  ></el-switch>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">{{ !currentProp.borderRadius ? "直角" : "圆角" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">{{ currentProp.titleBold ? "加粗体" : "常规体" }}</span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="settings-item flex item-center title-text-setting">
                <span class="mr20">页面间距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.padding"
                  ></el-slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 开启全局设置按钮 -->
      <div class="page-setting-btn" @click="openPageSetting" :class="{ active: showPageSetting }">
        <span class="hmicon icon-yemianshezhi"></span>
        <span>页面设置</span>
      </div>
    </div>
    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      v-if="show"
      noCircle
      noSquare
      :width="uploadWidth"
      :height="uploadHeight"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'mallDecoration' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
    <hm-filter-coupon
      :visible="selectCouponVisible"
      @saveCoupon="saveCoupon"
      @close="selectCouponVisible = false"
    ></hm-filter-coupon>
    <hm-filter-live
      :visible="selectLiveVisible"
      @saveLive="saveLive"
      @close="selectLiveVisible = false"
    ></hm-filter-live>
    <hm-filter-bargain
      :visible="selectBargainVisible"
      @saveBargain="saveBargain"
      @close="selectBargainVisible = false"
    ></hm-filter-bargain>
    <hm-filter-seckill
      :visible="selectSeckillVisible"
      @saveSeckill="saveSeckill"
      @close="selectSeckillVisible = false"
    ></hm-filter-seckill>
    <hm-filter-groupon
      :visible="selectGrouponVisible"
      @saveGroupon="saveGroupon"
      @close="selectGrouponVisible = false"
    ></hm-filter-groupon>
    <hm-filter-brand @saveBrand="saveBrand" @close="brandVisible = false" :visible="brandVisible"></hm-filter-brand>
    <!-- <hm-upload
      :hmUploadVisible="hmUploadVisible"
      fileDir="decoration"
      @cancleUpload="cancleUpload"
      @hmUploadSuccess="hmUploadSuccess"
    ></hm-upload> -->
    <hm-upload
      :hmUploadVisible="hmUploadVisible"
      @cancleUpload="cancleUpload"
      @hmUploadSuccess="hmUploadSuccess"
      :isUploadVideo="isUploadVideo"
    ></hm-upload>
    <hm-filter-hot
      @saveHotGoods="saveHotGoods"
      @close="hotVisible = false"
      :visible="hotVisible"
    ></hm-filter-hot>
  </div>
</template>

<script>
/* eslint vue/no-unused-components: [0] */
import { hmComponents, tabBarList, predefine } from "@/utils/tempData";
import html2canvas from "html2canvas";
import draggable from "vuedraggable";
import myUpload from "vue-image-crop-upload";
import HmUpload from "@/components/HmUpload";
import HmRichEditor from "@/components/HmRichEditor";
import tabBar from "@/components/HmMallComponent/tabBar";
import search from "@/components/HmMallComponent/search";
import notice from "@/components/HmMallComponent/notice";
import contactUs from "@/components/HmMallComponent/contactUs";
import dividingLine from "@/components/HmMallComponent/dividingLine";
import richText from "@/components/HmMallComponent/richText";
import titleText from "@/components/HmMallComponent/titleText";
import imageAdSelection from "@/components/HmMallComponent/imageAdSelection";
import imageTextNav from "@/components/HmMallComponent/imageTextNav";
import goodsList from "@/components/HmMallComponent/goodsList";
import coupon from "@/components/HmMallComponent/coupon";
import groupon from "@/components/HmMallComponent/groupon";
import seckill from "@/components/HmMallComponent/seckill";
import bargain from "@/components/HmMallComponent/bargain";
import live from "@/components/HmMallComponent/live";
import tabs from "@/components/HmMallComponent/tabs";
import cube from "@/components/HmMallComponent/cube";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import HmFilterBrand from "@/components/HmFilterBrand";
import HmFilterCoupon from "@/components/HmFilterCoupon";
import HmFilterBargain from "@/components/HmFilterBargain";
import HmFilterGroupon from "@/components/HmFilterGroupon";
import HmFilterSeckill from "@/components/HmFilterSeckill";
import HmFilterLive from "@/components/HmFilterLive";
import HmFilterHot from "@/components/HmFilterHot";
import hot from "@/components/HmMallComponent/hot";
import HotZone from "@/components/hotZone/Hotzone";
import guessYouLike from "@/components/HmMallComponent/guessYouLike";
import { mapGetters } from "vuex";
export default {
  name: "custom-clone",
  display: "Clone",
  order: 2,
  components: {
    tabBar,
    draggable,
    tabs,
    search,
    contactUs,
    groupon,
    dividingLine,
    myUpload,
    HmUpload,
    notice,
    richText,
    HmRichEditor,
    titleText,
    imageAdSelection,
    imageTextNav,
    goodsList,
    cube,
    seckill,
    bargain,
    live,
    HmFilterMicroShopGoods,
    HmFilterGroupGoods,
    HmFilterBrand,
    HmFilterCoupon,
    HmFilterLive,
    HmFilterBargain,
    HmFilterGroupon,
    HmFilterSeckill,
    coupon,
    hot,
    HotZone,
    guessYouLike,
    HmFilterHot,
  },
  data() {
    return {
      imgAdSelectionUpLoadType: "leftImgList",
      selectLiveVisible: false,
      selectCouponVisible: false,
      selectBargainVisible: false,
      selectGrouponVisible: false,
      selectSeckillVisible: false,
      brandVisible: false,
      tabList: [],
      groupGoodsVisible: false,
      hmUploadVisible: false,
      isRadio: false,
      goodsType: "",
      pageType: "",
      pageModel: "",
      layoutId: "",
      currentImageAd: "",
      currentIndex: "",
      currentParams: "",
      uploadType: "",
      uploadWidth: 20,
      uploadHeight: 20,
      predefine,
      showPageSetting: true,
      dialogVisible: false,
      show: false,
      title: "微页面标题",
      hotWord: "",
      activePreviewIndex: "",
      currentProp: {},
      currentTab: "",
      currentTabIconType: "",
      tabBarList,
      hmComponents,
      allComponents: [],
      previewComponents: [],
      currentLinkIndex: "",
      currentLinkPropName: "",
      selectGroupGoodsType: "",
      hotVisible: false,
      isUploadVideo: false,
    };
  },
  computed: mapGetters(["tempDetails", "microShopRouteList"]),
  watch: {
    tempDetails(val) {
      this.title = val.pageTitle || "微页面标题";
      if (val.pageConfig) {
        this.pageConfig = JSON.parse(val.pageConfig) || this.pageConfig;
        if (!this.pageConfig.fillBgType) {
          this.pageConfig.fillBgType = "custom";
          this.pageConfig.bg = "#f5f5f5";
        }
      }
      this.previewComponents = val.previewComponents
        ? JSON.parse(val.previewComponents)
        : [];
      console.log("this.previewComponents: ", this.previewComponents);
      this.previewComponents.forEach(v => {
        if (v.component === "hotZone") {
          v.prop.zonesInit = v.prop.zones;
        }
      });
      if (val.tabBarList) {
        this.tabBarList = JSON.parse(val.tabBarList);
      }
    },
    "currentProp.goodShowType": {
      handler(val) {
        if (val) {
          switch (val) {
            case "big":
              this.type = "大图";
              break;
            case "twoColumn":
              this.type = "一行两个";
              break;
            case "scroll":
              this.type = "横向滑动";
              break;
            default:
              break;
          }
        }
      },
      deep: true,
    },
    "currentProp.permutation": {
      handler(val) {
        if (val) {
          this.calcCubeList(val);
        }
      },
      deep: true,
    },
    "currentProp.type": {
      handler(val) {
        if (val) {
          this.currentProp.url = "";
        }
      },
      deep: true,
    },
    "currentProp.isSwiper": {
      handler(val) {
        if (val) {
          this.currentProp.marginBottom = 0;
        }
      },
      deep: true,
    },
  },
  created() {
    this.pageType = this.$route.query.pageType;
    this.pageModel = this.$route.query.pageModel;
    this.layoutId = this.$route.query.layoutId;
    this.mode = this.$route.query.mode;
    if (
      (this.pageModel === "customize" && this.layoutId) ||
      this.pageModel === "default"
    ) {
      this.$store.dispatch("queryTempDetails", {
        pageType: this.pageType,
        pageModel: this.pageModel,
        layoutId: this.layoutId,
      });
    }
    this.$store.dispatch("queryMicroShopList", {
      pageType: "page",
    });
    this.$store.dispatch("queryStoreStyle");
  },
  methods: {
    switchImageAdTemp(type) {
      if (type === "3") {
        this.imgAdSelectionUpLoadType = "leftImgList";
        if (this.currentProp.imgList.length) {
          this.currentProp.leftImgList = this.currentProp.imgList;
        } else {
          this.currentProp.leftImgList = [];
        }

        if (!this.currentProp.rightImgList) {
          this.currentProp.rightImgList = [];
        }
      } else {
        if (this.currentProp.leftImgList.length) {
          this.currentProp.imgList = this.currentProp.leftImgList;
        }
      }
      this.$forceUpdate();
    },
    changeCouponBg() {
      this.hmUploadVisible = true;
      this.uploadType = "coupon";
    },
    saveLive(data) {
      this.currentProp.liveList = data;
      this.selectLiveVisible = false;
    },
    addLiveRoom() {
      this.selectLiveVisible = true;
    },
    saveCoupon(data) {
      if (this.selsectCouponType === "coupon") {
        this.currentProp.couponList = data;
      } else if (this.selsectCouponType === "HotZone") {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].couponList = data;
        console.log("data: ", data);
        console.log("this.currentLinkIndex: ", this.currentLinkIndex);
        console.log("this.currentLinkPropName: ", this.currentLinkPropName);
      }
      this.selectCouponVisible = false;
    },
    saveSeckill(data) {
      this.selectSeckillVisible = false;
      this.currentProp.seckillList = data;
    },
    saveBargain(data) {
      this.selectBargainVisible = false;
      this.currentProp.bargainList = data;
    },
    saveGroupon(data) {
      this.selectGrouponVisible = false;
      this.currentProp.grouponList = data;
    },
    addCoupon() {
      this.selectCouponVisible = true;
    },
    addGroupon() {
      this.selectGrouponVisible = true;
    },
    addBargain() {
      this.selectBargainVisible = true;
    },
    addSeckill() {
      this.selectSeckillVisible = true;
    },
    changeCouponColorType() {
      this.currentProp.couponColor = "";
    },
    changeCouponFillType() {
      this.currentProp.bg = "";
    },
    addTabsGroupGoods(i) {
      this.groupGoodsVisible = true;
      this.selectGroupGoodsType = "tabs";
      this.currentIndex = i;
    },
    addTabNav() {
      this.currentProp.tabList.push({
        tabTitle: "",
        groupGoods: {},
      });
    },
    deleteCurrentTabs(i) {
      this.currentProp.tabList.splice(i, 1);
      this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    handleCloseGroup(prop, index) {
      if (!index && index !== 0) {
        this.currentProp.groupGoods = {};
        this.currentProp.hrefAddress = "";
      } else {
        this.currentProp[prop][index].groupGoods = {};
        this.currentProp[prop][index].hrefAddress = "";
      }
    },
    saveGroupGoods(row) {
      this.groupGoodsVisible = false;
      if (!this.selectGroupGoodsType) {
        if (!this.currentIndex && this.currentIndex !== 0) {
          this.currentProp.groupGoods = row;
        } else {
          this.currentProp[this.currentParams][
            this.currentIndex
          ].groupGoods = row;
          this.currentIndex = "";
          this.currentParams = "";
        }
      } else if (this.selectGroupGoodsType === "tabBarList") {
        this.tabBarList[this.currentIndex].groupGoods = row;
        this.currentIndex = "";
        this.selectGroupGoodsType = "";
      } else if (this.selectGroupGoodsType === "tabs") {
        this.currentProp.tabList[this.currentIndex].groupGoods = row;
        this.$refs.singleComponent[this.activePreviewIndex].changeTab(
          this.currentIndex
        );
        this.currentIndex = "";
        this.selectGroupGoodsType = "";
      }
    },
    saveBrand(row) {
      this.brandVisible = false;
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].brandInfo = row;
      } else {
        this.currentProp.brandInfo = row;
      }
      this.brandVisible = false;
    },
    // async queryGroupGoods(groupId) {
    //   const { storeCode } = getLoginUser();
    //   const { result } =  await this.$store.dispatch('queryGroupGoods', {
    // 			pageSize: 99999,
    // 			pageNo: 1,
    //       storeCode,
    // 			groupId,
    //   })
    //   const { records } = result
    //   this.$refs.singleComponent[this.activePreviewIndex].goodsList = records
    // },
    selectGroup(e, i, param) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
        if (i || i === 0) {
          this.currentIndex = i;
          this.currentParams = param;
        }
      }
    },
    handleCloseTabsGroup(i) {
      this.currentProp.tabList[i].groupGoods = {};
      this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    handleCloseTabBarGroup(i) {
      this.tabBarList[i].groupGoods = {};
    },
    selectTabBarGroup(e, i) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
        this.selectGroupGoodsType = "tabBarList";
        this.currentIndex = i;
      }
    },
    cancleUpload() {
      this.hmUploadVisible = false;
      this.isUploadVideo = false;
    },
    hmUploadSuccess(url) {
      this.isUploadVideo = false;
      switch (this.uploadType) {
        case "imageAd":
          if (this.currentProp.type !== "3") {
            this.currentProp.imgList[this.currentImageAd].src = url;
          } else {
            this.currentProp[this.imgAdSelectionUpLoadType][
              this.currentImageAd
            ].src = url;
          }
          break;
        case "cube":
          this.currentProp.cubeList[this.currentImageAd].src = url;
          break;
        case "coupon":
          this.currentProp.bg = url;
          break;
        case "hotZoneImage":
          this.currentProp.image = url;
          break;
        case "video":
          this.currentProp.src = url;
          break;
        case "topBgImg":
          this.pageConfig.topBgImg = url;
          break;
        case "pageConfigBg":
          this.pageConfig.bg = url;
          break;
        case "hotImg":
          this.currentProp.hotImg = url;
          break;
        default:
          break;
      }
      this.hmUploadVisible = false;
      this.$forceUpdate();
    },
    setLink(row) {
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].goodsInfo = row;
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      } else {
        this.currentProp.goodsInfo = row;
        this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    handleClose(v) {
      v.goodsInfo = {};
      v.brandInfo = {};
      v.hrefAddress = "";
      v.pageType = "";
    },
    openGoodsSelect(v, i, propName) {
      if (v.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      if (v.pageType === "brand") {
        this.brandVisible = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }

      if (v.pageType === "coupon") {
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      v.groupGoods = {};
      v.goodsInfo = {};
      v.couponList = [];
      v.hrefAddress = "";
      v.appid = "";
      v.brandInfo = {};
    },
    openGoodsSelectSingle() {
      if (this.currentProp.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      if (this.currentProp.pageType === "brand") {
        this.brandVisible = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      this.currentProp.goodsInfo = {};
      this.currentProp.brandInfo = {};
      this.currentProp.groupGoods = {};
      this.currentProp.hrefAddress = "";
    },
    handleCloseSingle() {
      this.currentProp.brandInfo = {};
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
      this.currentProp.pageType = "";
    },
    addGoods() {
      this.dialogVisible = true;
      this.isRadio = false;
    },
    saveGoods(data) {
      this.dialogVisible = false;
      this.currentProp.goodsList = this.currentProp.goodsList.filter(
        (v) => !v.isMock
      );
      this.currentProp.goodsList.push(...data);
    },
    setHotword() {
      this.previewComponents[this.activePreviewIndex].prop.hotWordList = [
        this.hotWord,
      ];
    },
    deleteCurrentComponent(i) {
      this.previewComponents.splice(i, 1);
      this.openPageSetting();
    },
    deleteCurrentGoods(i) {
      this.currentProp.goodsList.splice(i, 1);
      if (this.currentProp.goodsList && !this.currentProp.goodsList.length) {
        this.currentProp.goodsList.push({
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0,
        });
      }
    },
    addHotWord() {
      this.currentProp.hotWordList.push({
        word: "",
      });
    },
    setPlaceholder() {
      if (this.currentProp.hotWordList && this.currentProp.hotWordList.length) {
        this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
      }
    },
    async save() {
      this.previewComponents.forEach((v) => {
        if (v.component === "search") {
          if (v.prop.hotWordList.length) {
            v.prop.placeholder = v.prop.hotWordList[0].word;
          } else {
            v.prop.placeholder = "";
          }
        }
      });
      const canvas = await html2canvas(
        document.querySelector(".preview-wrapper"),
        {
          useCORS: true,
          backgroundColor: null,
        }
      );
      const previewImg = canvas.toDataURL("image/png");
      const params = {
        pageType: this.pageType,
        pageTitle: this.title,
        tabBarList: JSON.stringify(this.tabBarList),
        previewComponents: JSON.stringify(this.previewComponents),
        useType: "shop",
        previewImg,
      };
      let actionName = "";
      if (this.mode === "edit") {
        Object.assign(params, {
          micropageId: this.layoutId,
        });
        actionName = "editTemp";
      } else {
        actionName = "addCustomTemp";
      }
      await this.$store.dispatch(actionName, params);
      this.$message({
        type: "success",
        message: "操作成功！",
      });
      this.$router.back(-1);
    },
    back() {
      this.$confirm("退出将不会保存当前装修，确认退出?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        this.$router.back();
      });
    },
    deleteCardList(i, prop) {
      this.currentProp[prop].splice(i, 1);
      if (prop === "hotWordList") {
        if (
          this.currentProp.hotWordList &&
          this.currentProp.hotWordList.length
        ) {
          this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
        } else {
          this.currentProp.placeholder = "";
        }
      }
    },
    changeIcon(i, type) {
      this.uploadType = "navbar";
      this.uploadWidth = 40;
      this.uploadHeight = 40;
      this.show = true;
      this.currentTab = i;
      this.currentTabIconType = type;
    },
    setConcatImg() {
      this.uploadType = "contact";
      this.uploadWidth = 600;
      this.uploadHeight = 600;
      this.show = true;
    },
    changeImageTextNav(i) {
      this.uploadType = "imageTextNav";
      this.show = true;
      this.uploadWidth = 90;
      this.uploadHeight = 90;
      this.currentImageAd = i;
    },
    changeImageAd(i) {
      // if (this.currentProp.isSwiper) {
      //   this.uploadWidth = 1500;
      //   this.uploadHeight = 720;
      //   this.show = true;
      // } else {
      //   this.hmUploadVisible = true;
      // }
      this.hmUploadVisible = true;
      this.uploadType = "imageAd";
      this.currentImageAd = i;
    },
    changeCube(i) {
      this.uploadType = "cube";
      // this.show = true;
      // this.uploadWidth = 360;
      // this.uploadHeight = 360;
      this.hmUploadVisible = true;
      this.currentImageAd = i;
    },
    changeLogoUrl() {
      this.uploadType = "logoUrl";
      this.show = true;
      this.uploadWidth = 120;
      this.uploadHeight = 120;
    },
    cloneEnd(prop) {
      return JSON.parse(JSON.stringify(prop));
    },
    log(e) {
      if (e.added) {
        this.activePreviewIndex = e.added.newIndex;
        this.currentProp = {};
        this.currentProp = e.added.element.prop;
      } else if (e.moved) {
        this.activePreviewIndex = e.moved.newIndex;
      }
      this.showPageSetting = false;
    },
    openPageSetting() {
      this.currentProp = {};
      this.activePreviewIndex = "";
      this.showPageSetting = true;
    },
    selectPreviewItem(i, prop) {
      this.activePreviewIndex = i;
      this.currentProp = {};
      this.currentProp = prop;
      this.showPageSetting = false;
    },
    cropSuccess() {},
    toggleShow() {
      this.show = !this.show;
    },
    // 添加视频
    addVideoLink() {},
    // 添加底部导航栏
    addTabBarList() {
      this.tabBarList.push({
        hrefName: "自定义",
        open: true,
        hrefAddress: "",
        custom: true,
        iconPath: "",
        selectedIconpath: "",
        groupGoods: {},
      });
    },
    // 添加图文导航
    addImageTextNav() {
      this.currentProp.imageTextNavList.push({
        src:
          "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
        hrefAddress: "",
        title: "导航",
        goodsInfo: {},
        groupGoods: {},
      });
    },
    // 添加图片广告
    addImageAd() {
      if (this.currentProp.type === "3") {
        this.currentProp[this.imgAdSelectionUpLoadType].push({
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          hrefAddress: "",
          text: "",
          goodsInfo: {},
          groupGoods: {},
        });
      } else {
        this.currentProp.imgList.push({
          src:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          hrefAddress: "",
          text: "",
          goodsInfo: {},
          groupGoods: {},
        });
      }
      this.$forceUpdate();
    },
    deleteCurrentImageAd(i) {
      this.currentProp.imgList.splice(i, 1);
      this.currentProp[this.imgAdSelectionUpLoadType].splice(i, 1);
    },
    calcCubeList(val) {
      let length = this.currentProp.cubeList
        ? this.currentProp.cubeList.length
        : 0;
      let list = JSON.parse(JSON.stringify(this.currentProp.cubeList));
      if (val < length) {
        list = list.slice(0, val);
      } else if (val > length) {
        for (let i = 0; i < val - length; i++) {
          list.push({
            src:
              "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
            url: "",
            hrefAddress: "",
            goodsInfo: {},
            groupGoods: {},
          });
        }
      }
      this.currentProp.cubeList = list;
    },
    deleteCurrentImageTextNav(i) {
      this.currentProp.imageTextNavList.splice(i, 1);
    },
    cropUploadSuccess(jsonData) {
      const url = jsonData.result;
      switch (this.uploadType) {
        case "navbar":
          this.tabBarList[this.currentTab][this.currentTabIconType] = url;
          break;
        case "contact":
          this.currentProp.url = url;
          break;
        case "imageAd":
          this.currentProp.imgList[this.currentImageAd].src = url;
          break;
        case "imageTextNav":
          this.currentProp.imageTextNavList[this.currentImageAd].src = url;
          break;
        case "cube":
          this.currentProp.cubeList[this.currentImageAd].src = url;
          break;
        case "logoUrl":
          this.currentProp.logoUrl = url;
          break;
        default:
          break;
      }
    },
    deleteCurrentTabbar(i) {
      this.tabBarList.splice(i, i);
    },
    //热销活动
    addHotNav() {
      this.currentProp.hotList.push({
        hotTitle: "",
        appid: "",
        hrefAddress: "",
        groupGoods: {}
      });
    },
    changeHotImageAd() {
      this.hmUploadVisible = true;
      this.uploadType = "hotImg";
    },
    deleteCurrentHot(i) {
      this.currentProp.hotList.splice(i, 1);
      this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    addHotGroupGoods(i) {
      console.log(i)
      this.hotVisible = true;
      console.log("this.hotVisible:",this.hotVisible);
      this.selectGroupGoodsType = "hot";
      this.currentIndex = i;
    },
    handleCloseHotGroup(i,goodsIndex) {
      this.currentProp.hotList[i].groupGoods.splice(goodsIndex,1);
      // this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
    },
    saveHotGoods(row) {
      // console.log("row")
      // console.log(row)
      // console.log('this.selectGroupGoodsType')
      // console.log(this.selectGroupGoodsType)
      // console.log("this.currentPro")
      // console.log(this.currentProp)
      this.hotVisible = false;
      if (!this.selectGroupGoodsType) {
        if (!this.currentIndex && this.currentIndex !== 0) {
          this.currentProp.groupGoods = row;
        } else {
          this.currentProp[this.currentParams][
            this.currentIndex
          ].groupGoods = row;
          this.currentIndex = "";
          this.currentParams = "";
        }
      } else if (this.selectGroupGoodsType === "hot") {
        console.log("rowrowrowrow")
        console.log(row)
        this.currentProp.hotList[this.currentIndex].groupGoods = row;
        this.$refs.singleComponent[this.activePreviewIndex].changeTab(
          this.currentIndex
        );
        this.currentIndex = "";
        this.selectGroupGoodsType = "";
      }
    },
    //图片热区
    uploadHotZoneImage() {
      this.uploadType = "hotZoneImage";
      this.hmUploadVisible = true;
    },
    deleteCurrentCoupon(i, index) {
      this.currentProp.zones[i].couponList.splice(index, 1);
      this.$forceUpdate();
    },
    handleAddZone(zone) {
      if (this.currentProp.zones) {
        this.$set(zone, "goodsInfo", {});
        this.$set(zone, "hrefAddress", "");
        this.$set(zone, "groupGoods", {});
        this.$set(zone, "appid", "");
        this.$set(zone, "couponList", []);
        this.currentProp.zones.push(zone);
        this.currentProp.zonesInit = this.currentProp.zones;
      }
    },
    handleRemoveZone(index) {
      if (this.currentProp.zones) {
        this.currentProp.zones.splice(index, 1);
        this.currentProp.zonesInit = this.currentProp.zones;
      }
    },
    handleChangeZone() {},
    cropUploadFail() {},
  },
};
</script>
<style lang="scss">
.temp-container {
  .ql-editor {
    padding: 0;
  }
}
.image-ad-selection-upload {
  margin-bottom: 20px;
  .context {
    position: relative;
    height: 155px;
    width: 155px;
    border: 1px solid #ddd;
    text-align: center;
    background: #fafafa;
    &.active {
      border: 1px solid #e50065;
      background: #fdf1f6;
    }
    .el-radio {
      margin: 0;
    }
    .dot {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      &.active {
        .point {
          background: #ffd4e7;
          &.first {
            background: #e50065;
          }
        }
      }
      .point {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #ddd;
        margin-right: 5px;
      }
    }
  }
}
</style>
<style scoped lang="scss">
.icon-wrapper {
  overflow: hidden;
}
.temp-container {
  .component-list {
    background: #fff;
    padding: 20px;
    width: 219px;
    box-sizing: border-box;
    height: calc(100vh - 56px);
    .title {
      color: #ccc;
      font-size: 16px;
      margin-bottom: 31px;
    }
    .list-group {
      box-sizing: border-box;
    }
    .list-group-item {
      cursor: move;
      margin-bottom: 28px;
      width: 50%;
      text-align: center;
      padding: 10px;
      box-sizing: border-box;
      &:hover {
        transition: all 0.2s linear;
        background-color: #fddfeb !important;
        border-radius: 2px;
        color: rgb(226, 0, 93);
        .label {
          color: rgb(226, 0, 93);
        }
      }
      .hmicon {
        font-size: 24px;
      }
      .label {
        margin-top: 16px;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .preview-container {
    position: absolute;
    top: 220px;
    left: 219px;
    right: 360px;
    bottom: 0;
    user-select: none;
  }
  .preview-wrapper {
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
    width: 375px;
    height: 667px;
    margin: 0 auto;
    .preview-head {
      height: 64px;
      width: 375px;
      margin: 0 auto;
      background: url("https://imgcdn.hemiao100.com/hemiaoBase/download.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50%;
      position: relative;
      .preview-title {
        width: 180px;
        margin: 0 auto;
        height: 34px;
        line-height: 26px;
        text-align: center;
        padding-top: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .default-header,
    .footer {
      img {
        width: 100%;
      }
    }
    .preview-body {
      position: relative;
      .preview-list-group {
        height: 603px;
        .preview-list-group-item {
          position: relative;
          box-sizing: border-box;
          cursor: move;
          border: 2px solid transparent;
          min-height: 20px;
          .widget {
            position: absolute;
            top: 0;
            right: -40px;
            width: 34px;
            cursor: pointer;
            .widget-label {
              display: inline-block;
              background-color: #fff;
              width: 80px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              font-size: 12px;
              pointer-events: none;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            }
            .widget-icon {
              display: none;
            }
            &::before {
              content: "";
              width: 0;
              height: 0;
              border-width: 5px;
              border-style: solid;
              border-color: transparent #fff transparent transparent;
              position: absolute;
              bottom: 7px;
              left: -10px;
            }
          }
          &:hover {
            .widget-icon {
              display: block;
              cursor: pointer;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
              width: 40px;
              height: 28px;
              text-align: center;
              font-size: 16px;
              line-height: 28px;
              background: #fff;
              color: #e71370;
            }
            .widget-label {
              display: none;
              cursor: pointer;
            }
          }
          *:not(.widget-icon) {
            cursor: move !important;
          }
          video {
            min-height: 140px;
            width: 100%;
            display: block;
          }
          // &:last-child {
          //   // margin-bottom: 50px;
          // }
          &.active,
          &.active:hover {
            box-sizing: border-box;
            border: 2px solid #ea5798;
            cursor: move;
          }
          &:hover {
            box-sizing: border-box;
            border: 2px dashed #ea5798;
            cursor: move;
          }
        }

        .contact-us-item {
          position: absolute;
          bottom: 23px;
          width: 100%;
          z-index: 11;
          left: 0;
        }
        .list-group-item {
          transition: all 0.2s linear;
          background-color: #fddfeb !important;
          border-radius: 2px;
          color: #e2005d;
          text-align: center;
          .label {
            margin-top: 10px;
          }
        }
      }
      .preview-height-tag {
        position: absolute;
        left: -130px;
        bottom: 0;
        width: 130px;
        display: -ms-flexbox;
        display: flex;
        color: #a2a2a2;
        border-bottom: 1px solid #dedede;
        .preview-height-tag-text {
          padding-top: 4px;
          font-size: 12px;
        }
      }
    }
  }

  .options-container {
    width: 360px;
    position: absolute;
    top: 56px;
    box-sizing: border-box;
    padding-bottom: 100px;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    bottom: 0;
    background: #fff;
    .p20 {
      padding: 20px;
    }
    .have-bg-wrapper {
      padding: 0 20px 20px;
      background: #fafafa;
    }
    .title {
      color: #2b2b2b;
      font-weight: 500;
      font-size: 18px;
      margin-bottom: 18px;
    }
    .tips {
      margin: 18px 0 20px;
      font-size: 12px;
      color: #777;
    }
    .sub-title {
      color: #2b2b2b;
      margin-bottom: 20px;
    }
    .page-header {
      padding: 20px;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }
    .page-footer {
      font-size: 14px;
      .sub-title {
        background: #fff;
        padding: 20px;
      }
    }
  }

  .border-bottom {
    border-bottom: 1px solid #eee;
  }

  .page-setting {
    .tabbar-setting .tabbar-setting-item .icon-wrapper {
      img {
        width: 21px;
      }
    }
  }

  .page-setting-btn {
    position: absolute;
    right: 385px;
    top: 100px;
    width: 98px;
    height: 36px;
    text-align: center;
    font-size: 14px;
    background: #fff;
    border-radius: 2px;
    line-height: 36px;
    cursor: pointer;
    user-select: none;
    &.active {
      background: #e2005d;
      color: #fff;
      .hmicon {
        color: #fff;
      }
    }
    .hmicon {
      margin-right: 5px;
    }
  }
  .temp-header {
    height: 56px;
    line-height: 56px;
    background: #e50065;
    color: #fff;
    padding: 0 22px;
    font-size: 16px;
    user-select: none;
    .hmicon {
      color: #fff;
      font-size: 18px;
      margin-right: 10px;
    }
    .btn {
      cursor: pointer;
    }
    .title {
      font-size: 18px;
    }
    .sub-title {
      font-size: 14px;
    }
    .header-list {
      li {
        border-right: 1px solid #fff;
        padding: 0 22px;
      }
      li:last-child {
        padding-right: 0;
        border-right: 0;
      }
    }
  }
  .tabbar-setting {
    background: #fafafa;
    padding: 20px;
    .tabbar-setting-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;
      .delete-tab {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
      &:hover {
        .delete-tab {
          opacity: 1;
        }
      }
      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: auto;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
  .card-list {
    .card-list-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;

      &:hover {
        .card-item-delete {
          opacity: 1;
        }
      }
      .card-item-delete {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
    }
  }

  .component-setting {
    font-size: 14px;
    .have-bg-wrapper {
      padding: 20px;
      background: #fafafa;
    }

    .title-text-setting {
      .other-setting {
        padding: 20px;
        border-bottom: 1px solid #eee;
        li:last-child {
          margin-bottom: 0;
        }
      }
    }

    .shape {
      background: #fff;
      padding: 3px;
      width: 66px;
      height: 18px;
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      .content {
        background: #ffeaf3;
        height: 100%;
        width: 100%;
      }
      &.radius {
        .content {
          border-radius: 30px;
        }
      }
      &.active {
        border: 1px solid #e50065;
      }
      &.blank.active {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
      &.line.active {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      &.blank,
      &.line {
        width: 48px;
        height: 22px;
        font-size: 14px;
        text-align: center;
        box-shadow: none;
        &.active {
          background: #ffeaf3;
        }
        .el-radio {
          margin-right: 0;
        }
      }
    }

    .cube-setting {
      .shape {
        height: 50px;
        .column {
          background: #ffd4e7;
          border: 1px dotted #ffdfed;
          margin: 0 2px;
          height: 100%;
        }
      }
    }

    .goods-setting {
      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }

    .image-ad-setting {
      .tabbar-setting {
        .tabbar-setting-item {
          cursor: move;
        }
      }
      .tabbar-setting {
        padding: 0;
      }
      .icon-wrapper {
        img {
          width: 100%;
        }
      }
      .shape.no-swiper,
      .shape.double-swiper,
      .shape.swiper {
        height: 43px;
      }
      .shape {
        &.swiper {
          position: relative;
          &::before {
            content: "\B7\B7\B7";
            position: absolute;
            left: 50%;
            top: 25%;
            -webkit-transform: translate(-50%);
            transform: translate(-50%);
            color: red;
            font-size: 26px;
          }
        }
        &.double-swiper {
          .content {
            position: relative;
            width: 48%;
            &::before {
              content: "\B7\B7\B7";
              position: absolute;
              left: 50%;
              top: 25%;
              -webkit-transform: translate(-50%);
              transform: translate(-50%);
              color: red;
              font-size: 26px;
            }
          }
        }
      }
    }
    .other-setting {
      li {
        margin-bottom: 20px;
      }
    }

    .coupon-setting {
      .item-setting {
        padding: 0 20px 20px;
        .shape {
          height: 28px;
          .content {
            background-color: transparent;
          }
        }
        .style1 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c6e0a88dcb8ee9-c4c9-44bc-9343-b8754a1b26ad.png");
            background-size: 100% 100%;
          }
        }
        .style2 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/decoration/ps9addd5b82b7a6c1d-c4f4-419f-be3c-2dc65a83e0f6.png");
            background-size: 100% 100%;
          }
        }
      }

      .settings {
        padding: 20px;

        .label {
          width: 80px;
        }

        .settings-item {
          margin-bottom: 20px;
        }
      }

      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: auto;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }

    .groupon-setting {
      &.live-setting {
        .item-setting {
          &.top {
            .shape {
              height: 63px;
              width: 78px;
              .content {
                background-color: transparent;
              }
            }
            .style1 {
              .content {
                background-image: url("https://imgcdn.hemiao100.com/decoration/ps28a3f76a87c4ea71-aa49-49c8-91fe-271b6aa55fe8.png");
                background-size: 100% 100%;
              }
            }
            .style2 {
              .content {
                background-image: url("https://imgcdn.hemiao100.com/decoration/ps1c2f72bb04859ac6-523f-4cc2-8868-7f509b9f551f.png");
                background-size: 100% 100%;
              }
            }
          }
        }
      }
      .item-setting {
        padding: 0 20px 20px;
        &.top {
          .shape {
            height: 63px;
            width: 78px;
            .content {
              background-color: transparent;
            }
          }
          .style1 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/decoration/ps4602ec0679358453-15b6-43eb-b277-28db9ef60203.png");
              background-size: 100% 100%;
            }
          }
          .style2 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c9331763e24077-91a4-4d34-ae73-93c4088413a4.png");
              background-size: 100% 100%;
            }
          }
          .style3 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/decoration/ps61481c2ae2db809a-5470-48ed-b42a-fe31870e8c89.png");
              background-size: 100% 100%;
            }
          }
        }
      }

      .settings {
        padding: 20px;

        .label {
          width: 80px;
        }

        .settings-item {
          margin-bottom: 20px;
        }
      }

      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: auto;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
}

.setting-list {
  .title {
    margin-right: 20px;
  }
}

.link-wrapper {
  padding: 0 20px 20px;
}

.drag-tips {
  box-sizing: border-box;
  border: 2px solid #ea5798;
  padding: 15px;
  font-size: 12px;
}

.component-setting {
  font-size: 14px;
  .have-bg-wrapper {
    padding: 20px;
    background: #fafafa;
  }

  .title-text-setting {
    .other-setting {
      padding: 20px;
      border-bottom: 1px solid #eee;
      li:last-child {
        margin-bottom: 0;
      }
    }
  }

  .shape {
    background: #fff;
    padding: 3px;
    width: 66px;
    height: 18px;
    box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
    .content {
      background: #ffeaf3;
      height: 100%;
      width: 100%;
    }
    &.radius {
      .content {
        border-radius: 30px;
      }
    }
    &.active {
      border: 1px solid #e50065;
    }
    &.blank.active {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &.line.active {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &.blank,
    &.line {
      width: 48px;
      height: 22px;
      font-size: 14px;
      text-align: center;
      box-shadow: none;
      &.active {
        background: #ffeaf3;
      }
      .el-radio {
        margin-right: 0;
      }
    }
  }

  .cube-setting {
    .shape {
      height: 50px;
      .column {
        background: #ffd4e7;
        border: 1px dotted #ffdfed;
        margin: 0 2px;
        height: 100%;
      }
    }
  }

  .goods-setting {
    .icon-wrapper {
      position: relative;
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      border: 1px solid #ddd;
      margin-right: 10px;
      cursor: pointer;
      .change-icon {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        color: #fff;
        text-align: center;
        height: 24px;
        line-height: 24px;
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  .image-ad-setting {
    .tabbar-setting {
      .tabbar-setting-item {
        cursor: move;
      }
    }
    .tabbar-setting {
      padding: 0;
    }
    .icon-wrapper {
      img {
        width: 100%;
      }
    }
    .shape.no-swiper,
    .shape.double-swiper,
    .shape.swiper {
      height: 43px;
    }
    .shape {
      &.swiper {
        position: relative;
        &::before {
          content: "\B7\B7\B7";
          position: absolute;
          left: 50%;
          top: 25%;
          -webkit-transform: translate(-50%);
          transform: translate(-50%);
          color: red;
          font-size: 26px;
        }
      }
      &.double-swiper {
        .content {
          position: relative;
          width: 48%;
          &::before {
            content: "\B7\B7\B7";
            position: absolute;
            left: 50%;
            top: 25%;
            -webkit-transform: translate(-50%);
            transform: translate(-50%);
            color: red;
            font-size: 26px;
          }
        }
      }
    }
  }
  .other-setting {
    li {
      margin-bottom: 20px;
    }
  }

  .coupon-setting {
    .item-setting {
      padding: 0 20px 20px;
      .shape {
        height: 28px;
        .content {
          background-color: transparent;
        }
      }
      .style1 {
        .content {
          background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c6e0a88dcb8ee9-c4c9-44bc-9343-b8754a1b26ad.png");
          background-size: 100% 100%;
        }
      }
      .style2 {
        .content {
          background-image: url("https://imgcdn.hemiao100.com/decoration/ps9addd5b82b7a6c1d-c4f4-419f-be3c-2dc65a83e0f6.png");
          background-size: 100% 100%;
        }
      }
    }

    .settings {
      padding: 20px;

      .label {
        width: 80px;
      }

      .settings-item {
        margin-bottom: 20px;
      }
    }

    .icon-wrapper {
      position: relative;
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      border: 1px solid #ddd;
      margin-right: 10px;
      cursor: pointer;
      img {
        width: auto;
      }
      &.no-bg {
        background: #f0f0f0;
      }
      .change-icon {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        color: #fff;
        text-align: center;
        height: 24px;
        line-height: 24px;
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  .groupon-setting {
    &.live-setting {
      .item-setting {
        &.top {
          .shape {
            height: 63px;
            width: 78px;
            .content {
              background-color: transparent;
            }
          }
          .style1 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/decoration/ps28a3f76a87c4ea71-aa49-49c8-91fe-271b6aa55fe8.png");
              background-size: 100% 100%;
            }
          }
          .style2 {
            .content {
              background-image: url("https://imgcdn.hemiao100.com/decoration/ps1c2f72bb04859ac6-523f-4cc2-8868-7f509b9f551f.png");
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .item-setting {
      padding: 0 20px 20px;
      &.top {
        .shape {
          height: 63px;
          width: 78px;
          .content {
            background-color: transparent;
          }
        }
        .style1 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/decoration/ps4602ec0679358453-15b6-43eb-b277-28db9ef60203.png");
            background-size: 100% 100%;
          }
        }
        .style2 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c9331763e24077-91a4-4d34-ae73-93c4088413a4.png");
            background-size: 100% 100%;
          }
        }
        .style3 {
          .content {
            background-image: url("https://imgcdn.hemiao100.com/decoration/ps61481c2ae2db809a-5470-48ed-b42a-fe31870e8c89.png");
            background-size: 100% 100%;
          }
        }
      }
    }

    .settings {
      padding: 20px;

      .label {
        width: 80px;
      }

      .settings-item {
        margin-bottom: 20px;
      }
    }

    .icon-wrapper {
      position: relative;
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      border: 1px solid #ddd;
      margin-right: 10px;
      cursor: pointer;
      img {
        width: auto;
      }
      &.no-bg {
        background: #f0f0f0;
      }
      .change-icon {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        color: #fff;
        text-align: center;
        height: 24px;
        line-height: 24px;
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }
}
</style>
